import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { Observable, Subject, asyncScheduler, of } from 'rxjs';
import { subscribeOn, takeUntil } from 'rxjs/operators';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'app-order-summary-right',
  templateUrl: './order-summary-right.component.html',
  styleUrls: ['./order-summary-right.component.scss'],
  standalone: false
})
export class OrderSummaryRightComponent {
  @Input()
  orderSummary: any;
  isMobile: boolean;
  @Input() subTotal: any;
  activeStep: any;
  @Input()
  minOrderCharge: any;
  fleetPrideGroup: any;
  @Input() total: any;
  showCorePrice$ = this.custIDService.showCorePrice$;
  showNetPrice$ = this.custIDService.showNetPrice$;
  showListPrice$ = this.custIDService.showListPrice$;
  private readonly destroy$ = new Subject<void>();
  constructor(public breakpointObserver: BreakpointObserver,
    private kbCheckoutService: KbCheckOutService,
    private cdr: ChangeDetectorRef, public custIDService: CustomerIdService,
    private activecart: ActiveCartFacade) { }
  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = result.matches;
      });

    this.kbCheckoutService.activeStep.pipe(takeUntil(this.destroy$)).subscribe(item => {
      this.activeStep = item;
    })
    this.custIDService.fleetPrideGroup$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    })
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();

  }
}